export default __webpack_public_path__ + "static/media/gmail.f1231984.svg";